import axios from 'axios';
import ApiClient from './ApiClient';

class WhatsappForwardsAPI extends ApiClient {
  constructor() {
    super('whatsapp_qr', { accountScoped: true });
  }

  send(messageId, contactId, requestId) {
    return axios.post(`${this.url}/messages/${messageId}/forward`, {
      contact_id: contactId,
      request_id: requestId,
    });
  }
}

export default new WhatsappForwardsAPI();
